var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencyNok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136720)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1516_136720)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9.00391,
    y: -1,
    width: 46.1221,
    height: 30.6785,
    rx: 5.76455,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1182 -1H-9.00391V29.6785H37.1182V-1Z",
    fill: "#BA0C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.00391 14.3393H37.1182ZM7.76778 -1V29.6785Z",
    fill: "#000008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.00391 14.3393H37.1182M7.76778 -1V29.6785",
    stroke: "white",
    strokeWidth: 8.38584
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.00391 14.3393H37.1182ZM7.76778 -1V29.6785Z",
    fill: "#000008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.00391 14.3393H37.1182M7.76778 -1V29.6785",
    stroke: "#00205B",
    strokeWidth: 4.19292
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1516_136720"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9.00391,
    y: -1,
    width: 46.1221,
    height: 30.6785,
    rx: 5.76455,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyNok);
export default __webpack_public_path__ + "static/media/Currency=NOK.6c77ca873a04ef4915804f184fb27f84.svg";
export { ForwardRef as ReactComponent };